// src/Redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import aboutUsReducer from "./slicer/aboutUsSlicer"
import ITServicesSlicer from  "./slicer/ITServicesSlice";
import GalleryAndNewsSlicer from "./slicer/GalleryAndNewsSlice";
import contactUsSlice from "./slicer/contactUsSlice"
import CQASlice from "./slicer/CQASlice"
import departmentSlice from "./slicer/departmentSlice"
import hodSlice from "./slicer/hodMessagesSlice"
import staffSlice from "./slicer/staffSlice"
import degreeSlice from "./slicer/degreeSlice"
import applicationSlice from "./slicer/applicationsSlice"
import programSlice from "./slicer/programSlice"
import loanSlice from "./slicer/loanSlicer"
import scholarshipSlice from "./slicer/scholarshipSlice"


const store = configureStore({
  reducer: {
    
    aboutUs: aboutUsReducer,
    ITServices : ITServicesSlicer,
    GalleryAndNews: GalleryAndNewsSlicer,
    ContactUs : contactUsSlice,
    CQA: CQASlice,
    department: departmentSlice,
    hodMessages: hodSlice,
    staff: staffSlice,
    degree: degreeSlice,
    applications: applicationSlice,
    program: programSlice,
    loan: loanSlice,
    scholarship: scholarshipSlice,

  },
});

export default store;